import { useStores, virtualCardStore } from '../../stores';
import VirtualCard from '../../pages/Wallet/VirtualCard';
import React, { useState, useEffect } from 'react';
import { MimaToastUtil } from '../../components';
import constant from '../../utils/constant';
import { VirtualCardController } from '../../controllers';
import { toJS } from 'mobx';


const VirtualCardContainer = ({ closeModal }) => {
	const { cardDetails } = virtualCardStore || {};

	const [isCardAvailable, setIsCardAvailable] = useState(false);
	const [loading, setLoading] = useState(true);
	const [confirmAction, setConfirmAction] = useState("")

	useEffect(() => {
		const getCard = async () => {
			setLoading(true);
			const { status, errorMessage } = await VirtualCardController.viewVirtualCard();
			if (status === constant.Success) {
				setIsCardAvailable(true);
				setLoading(false);
			} else {
				setIsCardAvailable(false);
				setLoading(false);
			}
		};

		getCard();
	}, []);


	const createNewCard = async () => {
		setLoading(true);

		const { status, errorMessage } = await VirtualCardController.createVirtualCard();
		if (status === constant.Success) {
			MimaToastUtil.success({ message: constant.Success });
			setIsCardAvailable(true);
			setLoading(false);
		} else {
			MimaToastUtil.error({ message: errorMessage });
			setLoading(false);
		}

	}

	const goBack = () => {
		if (confirmAction !== "") {
			setConfirmAction("")
		} else {
			closeModal();
		}

	}

	const handleCardAction = async () => {
		if (confirmAction === 'Unfreeze Card') {
			setLoading(true);
			const { status, errorMessage } = await VirtualCardController.unfreezeVirtualCard();
			if (status === constant.Success) {
				MimaToastUtil.success({ message: 'Card has been unfrozen' });
				setConfirmAction("")
				setLoading(false);
				// closeModal();
			} else {
				MimaToastUtil.error({ message: errorMessage });
				setConfirmAction("")
				setLoading(false);
			}
		}

		if (confirmAction === 'Freeze Card') {
			setLoading(true);
			const { status, errorMessage } = await VirtualCardController.freezeVirtualCard();
			if (status === constant.Success) {
				MimaToastUtil.success({ message: 'Card has been frozen' });
				setConfirmAction("")
				setLoading(false);
				// closeModal();
			} else {
				MimaToastUtil.error({ message: errorMessage });
				setConfirmAction("")
				setLoading(false);
			}
		}

		if (confirmAction === 'Deactivate Card') {
			setLoading(true);
			const { status, errorMessage } = await VirtualCardController.deactivateVirtualCard();
			if (status === constant.Success) {
				MimaToastUtil.success({ message: 'Card has been deactivated' });
				setConfirmAction("")
				setLoading(false);
				closeModal();
			} else {
				MimaToastUtil.error({ message: errorMessage });
				setConfirmAction("")
				setLoading(false);
			}
		}
	}


	return (
		<VirtualCard
			cardDetails={cardDetails}
			closeModal={closeModal}
			loading={loading}
			goBack={goBack}
			isCardAvailable={isCardAvailable}
			setIsCardAvailable={setIsCardAvailable}
			confirmAction={confirmAction}
			setConfirmAction={setConfirmAction}
			handleCardAction={handleCardAction}
			createNewCard={createNewCard}
		/>
	);
};

export default VirtualCardContainer;
